import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 60px;\n  width: 60px;\n  text-align: center;\n  padding: 0;\n  margin: 0 auto 10px auto;\n  background-color: rgba(25, 25, 25, 0.06);\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  height: 16px;\n  text-align: center;\n  margin: 0;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: center;\n  margin-bottom: 6px;\n  margin-top: 0;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { RELOAD_BUTTON } from '../utils/testing/TestIDs';
var ErrorContainer = styled.div(_templateObject());
var ErrorMessage = styled.p(_templateObject2(), function (props) {
  return props.theme.colors.white;
});
var ErrorSubMessage = styled.p(_templateObject3(), function (props) {
  return props.theme.colors.white;
}); // @ts-ignore
//using hex values for opacity for color

var IconContainer = styled.div.attrs({
  'data-testid': RELOAD_BUTTON
})(_templateObject4());
export var ErrorState = function ErrorState(_ref) {
  var onClickReload = _ref.onClickReload;
  return /*#__PURE__*/React.createElement(ErrorContainer, {
    onClick: onClickReload
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ReloadWhite,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement(ErrorMessage, null, 'Unable to load data'), /*#__PURE__*/React.createElement(ErrorSubMessage, null, 'Tap to retry'));
};